import { Directive, ElementRef, forwardRef, HostListener, OnInit, Renderer2 } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

@Directive({
    selector: '[appTextareaResize]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextareaResizeDirective),
            multi: true,
        },
    ],
    standalone: false
})
export class TextareaResizeDirective implements OnInit, ControlValueAccessor {
  public onChange: any = () => {}
  public onTouched: any = () => {}

  constructor(private _elementRef: ElementRef<HTMLInputElement>, private _renderer: Renderer2) {}

  @HostListener(':input', ['$event.target.value'])
  onInput = (_: any) => {
    this.resize()
  }

  public writeValue(value: string | null): void {
    const val = value || ''
    this._renderer.setProperty(this._elementRef.nativeElement, 'value', val.toString())
    this.resize()
  }

  public registerOnChange(fn: any): void {
    this.onInput = (value: string) => {
      fn(value)
      this.resize()
    }
  }

  public registerOnTouched(fn: any): void {}

  ngOnInit() {
    if (this._elementRef.nativeElement.scrollHeight) {
      this.resize()
    }
  }

  private resize() {
    this._elementRef.nativeElement.style.height = '0'
    this._elementRef.nativeElement.style.height =
      this._elementRef.nativeElement.scrollHeight + 5 + 'px'
  }
}
